import { getFormattedSearchSelectItem } from 'components/product-comparison-grid/product-comparison-card/utils';
import { CartResponse } from 'services/cart/types';
import { PRIME_PDP_KITS } from '../../constants/constants';

export const createHandleSelectItemEventGa = (
  clickedItem,
  mergedKitResponse,
  cartDetails: CartResponse,
  storeId: string,
  fireSelectItemEvent?: (event) => void
) => {
  const itemListNameId = PRIME_PDP_KITS;
  const matchedItem =
    mergedKitResponse.find(
      (item) => item.partNumber === clickedItem.partNumber
    ) || clickedItem;
  fireSelectItemEvent({
    item: getFormattedSearchSelectItem(cartDetails?.orderHeader, matchedItem),
    partName: matchedItem && `${matchedItem.partNumber}: ${matchedItem.name}`,
    locationId: storeId,
    itemSummary: matchedItem,
    isSearchPageEvent: true,
    itemListId: itemListNameId,
    itemListName: itemListNameId,
    serialNumber: '',
    fitment: ''
  });
};
